import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment.prod'
import { Observable } from 'rxjs';
import { Firestore, collection, collectionData } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})

export class CategoryService {

  private firestore = inject(Firestore);

  constructor(private http: HttpClient) { }

  getCategories(userId: string, appId: string): Observable<any[]> {
    const categoriesRef = collection(this.firestore, `Users/${userId}/Apps/${appId}/Categories`);
    return collectionData(categoriesRef, { idField: 'id' });
  }

  showOne(id: number){
    return this.http.get(environment.apiUrl + 'app/' + id)
  }

  createOrUpdateCategory(data: any){
    return this.http.post(environment.apiUrl + "auth/createOrUpdate/category/", data);
  }

  deleteCategory(userId: string, appId: string, catId: string){
    return this.http.post(environment.apiUrl + "auth/delete/category/", {userId: userId, appId: appId, catId: catId});
  }

}
